<template>
  <main-menu mstyle="dark"></main-menu>

  <section class="section categories">
    <div class="categories__top">
      <p class="title colored">Categories</p>
      
      <div class="sort_block">
        <span class="sort_param selected">Sort by name</span>
        <span class="divider">|</span>
        <span class="sort_param">Sort by popularity</span>
      </div>
    </div>

    <div class="categories__content">
      <div class="content__form">
        <form @submit.prevent="searchCategory()" class="search_form">
          <h2>Select your category and state</h2>
          <label class="search_input">
            <p class="category_select_name">Category</p>
            <select class="category_select"
                    required
                    v-model="selected_category"
                    placeholder='Select your category'>
              <option selected value=''>Select your category</option>   
              <option v-for="(category, index) in categories"
                      :key="index"
                      :value="category.url">
              {{ category.name }}
              </option>
            </select>
          </label>

          <label class="search_input">
            <p class="category_select_name">State</p>
            <select class="category_select"
                    v-model="selected_state">
              <option selected disabled value=''>Select your state</option>
              <option v-for="(state, index) in states"
                       :key="index">
              {{ state }}
              </option>
            </select>
          </label>

          <button @click="searchCategory()" class="category_select_button">Search</button>

          <small class="form_document">
            By clicking on search button you 
            agree to vaniplate
            <router-link to='/terms'>terms and agreement</router-link>
          </small>

        </form>
      </div>


      <div class="content__plates">
        <div class="plates_list">
          <div class="plate_wrapper" 
               v-for="(plate, index) in current_category.objects" 
               :key="index">
            <div class="license_plate" 
                 @click="routeToText(plate.name, $route.params.state ? $route.params.state : states[index])">
              <img :src="`${static_server}img/plates_small/${$route.params.state ? $route.params.state : states[index]}.png`" />
              <p class="plate_text">{{ plate.name }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section class="section insurance_finder">
    <div class="insurance_finder__block">
      <div class="block_img">
        <img src="@/assets/img/mail.svg"/>
      </div>

      <div class="block_text">
        <p class="pretitle">Insurance finder</p>
        <h1 class="title">Vaniplate insurance finder</h1>
        <p class="description">
          Did you know Vanity Plate owners Save on Average 11% a month? 
          becuse they are responsible drivers
        </p>

        <form @submit.prevent="successInsurance()" class="round_input">    

          <input type='text' class="input__textinput" required v-model="zipcode" placeholder="Enter your zipcode" />

          <button class="submit_round_button" type="submit">
            <span v-if="!form_loading">Subscribe</span>
            <div class="form_spinner" v-if="form_loading"></div>
          </button>
        </form>
      </div>
    </div>

  </section>

  <my-footer></my-footer>

  <transition name="fade" appear>
    <thank-you :show="show_thank" @close="show_thank = false" v-if="show_thank"></thank-you>
  </transition>
</template>

<script>
import MainMenu from '../components/MainMenu'
import Footer from '../components/Footer'
import { mapActions, mapGetters, mapState } from 'vuex'

export default {
  name: "Categories",
  components: {
    'main-menu': MainMenu,
    'my-footer': Footer
  },

  data() {
    return {
      selected_state: '',
      selected_category: '',

      current_category: {},

      zipcode: '',

      form_loading: false,
      show_thank: false
    }
  },

  computed: {
    ...mapState(['categories', 'states', 'server', 'static_server', 'auth_headers']),
    ...mapGetters(['getRandomInt'])
  },

  watch: {
    '$route.fullPath': {
      handler() {
        if (this.$route.fullPath.includes('/categories/')) {
          this.getCategory()
          this.installParams()
        }
      }
    }
  },

  mounted() {
    this.getCategory()
    this.installParams()
  },

  methods: {

    installParams() {
      if (this.$route.params.category) {
        this.selected_category = this.$route.params.category
      }
      if (this.$route.params.state) {
        this.selected_state = this.$route.params.state
      } 

    },

    getCategory() {
      this.$axios.get(`${this.server}categories/${this.$route.params.category}/`,
        {headers: this.auth_headers})
        .then((response) => {
          this.current_category = response.data
        })
        .catch((error) => {
          this.$router.push('/404')
        })
    },

    searchCategory() {
      this.$router.push(`/categories/${this.selected_category}${this.selected_state ? '/' + this.selected_state : ''}`)
    },

    successInsurance() {
      this.form_loading = true
      this.$axios.post(`${this.server}insurance/`,
        {zipcode: this.zipcode})
        .then((response) => {
          this.form_loading = false
          this.zipcode = ''
          this.show_thank = true
        })
    },

    routeToText(text, state) {  
      let usa_state = state || this.getRandomInt
      this.$router.push(`/${usa_state}/${text}`)
    }
  }
}
</script>

<style lang="sass" scoped>
@import "@/assets/sass/style.sass"
</style>